<template>
  <b-collapse tag="ul" :class="className" :visible="open" :id="idName" :accordion="accordianName">
    <li v-for="(item,index) in visibleItems" :key="index" :class="{ active: activeLink(item), 'menu-dropdown': isDropdown(item), 'menu-dropdown-open': isDropdown(item) && isExpanded(item, index) }">
      <a v-if="isDropdown(item)" href="#" role="button" class="iq-waves-effect menu-dropdown-toggle" :aria-expanded="String(isExpanded(item, index))" :aria-controls="submenuId(index)" @click.prevent.stop="toggleDropdown(item, index)" @keydown.space.prevent="toggleDropdown(item, index)">
        <span v-if="isSvgIcon(item)" class="menu-response-icon" v-html="item.icon"></span>
        <i v-else-if="item.iconClass && !hideDropdownClassIcon(item)" :class="item.icon"/>
        <span v-else-if="!item.iconClass" v-html="item.icon"></span>
        <span>{{ $t(item.menu) }}</span>
        <span class="menu-dropdown-arrow" aria-hidden="true"></span>
      </a>
      <a v-else-if="hasComponent(item) && item.url" :href="item.url" class="iq-waves-effect" :class="{ active: activeLink(item) }">
        <span v-if="isSvgIcon(item)" class="menu-response-icon" v-html="item.icon"></span>
        <i v-else-if="item.iconClass" :class="item.icon"/>
        <span v-else v-html="item.icon"></span>
        <span>{{ $t(item.menu) }}</span>
      </a>
      <template v-else>
        <i v-if="!item.heading && depth === 0" class="ri-subtract-line" />
        <span v-if="!item.heading && depth === 0">{{ $t(item.menu) }}</span>
        <router-link :to="{ name: item.props, query: { menuId: item.menuId } }" v-if="(item.heading || depth > 0) && item.className != 'true' && !item.component" class="iq-waves-effect" :class="{ active: activeLink(item) }" v-b-toggle="item.menu">
          <span v-if="isSvgIcon(item)" class="menu-response-icon" v-html="item.icon"></span>
          <i v-else-if="item.iconClass" :class="item.icon"/>
          <span v-else v-html="item.icon"></span>
          <span>{{ $t(item.menu) }}</span>
        </router-link>
      </template>
      <List v-if="isDropdown(item)" :items="childItems(item)" class-name="iq-submenu menu-nested-list" :open="isExpanded(item, index)" :id-name="submenuId(index)" :accordian-name="null" :depth="depth + 1" :horizontal="horizontal"/>
    </li>
    <li v-if="depth === 0" class="d-flex mt-5" style="cursor: pointer;overflow:auto;top:180px;">
      <button type="button" class="btn btn-secondary btn-block" @click="clearCache" style=""> 
        <i class="fa fa-refresh mr-2" />
        <span>Clear Cache</span>
      </button>
    </li>
  </b-collapse>
</template>
<script>
import { xray } from '../../../config/pluginInit'
export default {
  name: 'List',
  props: {
    items: Array,
    className: { type: String, default: 'iq-menu' },
    horizontal: Boolean,
    open: { type: Boolean, default: false },
    idName: { type: String, default: 'sidebar' },
    accordianName: { type: String, default: 'sidebar' },
    depth: { type: Number, default: 0 }
  },
  data () {
    return { expandedMenus: {} }
  },
  computed: {
    visibleItems () {
      return (this.items || []).filter(item => {
        const heading = item.heading === true || item.heading === 1 || item.heading === '1' || item.heading === 'true'
        return !(heading && (item.className === true || item.className === 'true'))
      })
    }
  },
  methods: {
    childItems (item) {
      return Array.isArray(item.child) ? item.child : (Array.isArray(item.children) ? item.children : [])
    },
    isDropdown (item) {
      const headingValue = item.heading
      const heading = headingValue === true || headingValue === 1 || headingValue === '1' || headingValue === 'true'
      const hasChildren = this.childItems(item).length > 0
      const placeholderUrl = item.url === null || item.url === '#' ||
        (hasChildren && (item.url === undefined || item.url === ''))
      return (heading || this.depth > 0) && placeholderUrl
    },
    hasComponent (item) {
      return item.component !== null && item.component !== undefined
    },
    hideDropdownClassIcon (item) {
      const heading = item.heading === true || item.heading === 1 || item.heading === '1' || item.heading === 'true'
      return heading && (item.url === null || item.url === '#')
    },
    isSvgIcon (item) {
      return typeof item.icon === 'string' && /^\s*<svg\b/i.test(item.icon)
    },
    submenuId (index) {
      return `${this.idName}-submenu-${index}`
    },
    containsActiveLink (item) {
      return this.activeLink(item) || this.childItems(item).some(child => this.containsActiveLink(child))
    },
    isExpanded (item, index) {
      return Object.prototype.hasOwnProperty.call(this.expandedMenus, index)
        ? this.expandedMenus[index]
        : this.childItems(item).some(child => this.containsActiveLink(child))
    },
    toggleDropdown (item, index) {
      this.$set(this.expandedMenus, index, !this.isExpanded(item, index))
    },
    activeLink (item) {
      return xray.getActiveLink(item, this.$route.name)
    },
    clearCache() {
      var all_cookies = document.cookie.split(";");
      for (var i = 0; i < all_cookies.length; i++) {
          var single_cookie = all_cookies[i];
          var cookie_index = single_cookie.indexOf("=");
          var cookie_name = cookie_index > -1 ? all_cookies.substr(0, cookie_index) : single_cookie;
          document.cookie = cookie_name + "=;expires=" + new Date().toUTCString();
      }

      var cookies = document.cookie.split("; ");
      for (var c = 0; c < cookies.length; c++) {
          var d = window.location.hostname.split(".");
          while (d.length > 0) {
              var cookieBase = encodeURIComponent(cookies[c].split(";")[0].split("=")[0]) + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=' + d.join('.') + ' ;path=';
              var p = location.pathname.split('/');
              document.cookie = cookieBase + '/';
              while (p.length > 0) {
                  document.cookie = cookieBase + p.join('/');
                  p.pop();
              };
              d.shift();
          }
      }

      window.location.reload(true);
    }
  }
}
</script>

<style scoped>
.iq-sidebar-menu li.menu-dropdown,
.iq-sidebar-menu .menu-nested-list > li.active {
  background: transparent !important;
}
.iq-sidebar-menu li.menu-dropdown > .menu-dropdown-toggle {
  display: flex;
  align-items: center;
}
.iq-sidebar-menu li.menu-dropdown-open > .menu-dropdown-toggle {
  background: #fff;
  color: #1d326f;
  border-radius: 15px;
}
.iq-sidebar-menu .menu-nested-list {
  margin: 0;
  padding-left: 30px;
  list-style: none;
}
.iq-sidebar-menu .menu-nested-list > li > a {
  padding: 16px 0;
  background: transparent !important;
  color: #fff !important;
  border-radius: 0;
}
.iq-sidebar-menu .menu-nested-list > li > a:hover,
.iq-sidebar-menu .menu-nested-list > li.active > a,
.iq-sidebar-menu .menu-nested-list > li > a.active {
  background: transparent !important;
  color: #ff8500 !important;
}
.iq-sidebar-menu .menu-dropdown-toggle > .menu-dropdown-arrow {
  flex-shrink: 0;
  width: 8px;
  height: 8px;
  margin: -4px 5px 0 auto;
  border-right: 2px solid currentColor;
  border-bottom: 2px solid currentColor;
  transform: rotate(-45deg);
}
.iq-sidebar-menu .menu-dropdown-open > .menu-dropdown-toggle > .menu-dropdown-arrow {
  transform: rotate(45deg);
}
.iq-sidebar-menu .menu-nested-list .menu-dropdown-arrow {
  width: 0;
  height: 0;
  margin-top: 0;
  border: 5px solid transparent;
  border-right: 0;
  border-left: 7px solid currentColor;
  transform: none;
}
.iq-sidebar-menu .menu-nested-list .menu-dropdown-open > .menu-dropdown-toggle > .menu-dropdown-arrow {
  transform: rotate(90deg);
}
.menu-response-icon {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  width: 20px;
  margin-right: 10px;
}
.menu-response-icon ::v-deep svg {
  width: 20px;
  height: 20px;
}
</style>
